import { getAnalytics, getHeader, getPageData } from "../api/app";
import ContentPage from "../components/contentPage/ContentPage";
import PageDescription from "../components/baseComponents/head/pageDescription/PageDescription";
import React from "react";
import { createMetaData } from "../utils/data/createMetaData";
import classNames from "classnames";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import Head from "next/head";
import { NEXT_PUBLIC_BASE_URL } from "../constants/copyright";

export default function FilterPage({ data, page, currentCategory }) {
  const { seo_title, seo_text, image } = currentCategory;
  const canonicalUrl = `${NEXT_PUBLIC_BASE_URL}/${page}`;

  return (
    <>
      <Head>
        <link rel="canonical" href={canonicalUrl} />
        <meta name="menuCategory" content={page} />
      </Head>

      <div className="container">
        <PageDescription
          {...createMetaData(seo_title, seo_text, image, null, null, canonicalUrl, page)}
        />

        <SwitchTransition>
          <CSSTransition
            key={`filter-${page}`}
            timeout={500}
            classNames="content-page"
          >
            <ContentPage
              data={data}
              className={classNames("", {
                [`content-page_${page}`]: page,
              })}
            />
          </CSSTransition>
        </SwitchTransition>
      </div>
    </>
  );
}

export async function getStaticPaths() {
  const header = await getHeader();
  const headings = header?.headings || [];

  const paths = headings
    .filter(({ href }) => href !== "/") // ✅ убрали главную
    .map(({ href }) => ({
      params: { page: href.slice(1) },
    }))
    .filter(({ params: { page } }) => page !== "goroskop");

  return {
    paths,
    fallback: "blocking",
  };
}
export async function getStaticProps({ params }) {
  const page = params?.page;

  if (!page) {
    return {
      notFound: true,
      revalidate: 10,
    };
  }

  const now = () => new Date().toLocaleString();

  const analyticsPromise = getAnalytics().catch((e) => {
    console.error(`${now()} [page] getAnalytics failed:`, e);
    return null;
  });

  const headerPromise = getHeader().catch((e) => {
    console.error(`${now()} [page] getHeader failed:`, e);
    return null;
  });

  const pageDataPromise = getPageData(page).catch((e) => {
    console.error(`${now()} [page] getPageData failed:`, e);
    return null;
  });

  const [analytic, header, pageData] = await Promise.all([
    analyticsPromise,
    headerPromise,
    pageDataPromise,
  ]);

  const headings = header?.headings || [];
  const currentCategory = headings.find((item) => item.href.slice(1) === page);

  if (!currentCategory) {
    return {
      notFound: true,
    };
  }

  if (!pageData) {
    return {
      notFound: true,
    };
  }

  const data = {
    ...pageData,
    header,
    page,
    items: pageData?.content?.items || [],
  };

  return {
    props: {
      analytic,
      data,
      page,
      currentCategory,
    },
    revalidate: 10,
  };
}



